import { Cpu } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="border-t bg-secondary/20 py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <Link to="/gpu-comparison" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-nvidia to-amd flex items-center justify-center">
              <Cpu className="w-5 h-5 text-white" />
            </div>
            <span className="font-bold">GPU Compare</span>
          </Link>

          {/* Links */}
          <nav className="flex flex-wrap items-center justify-center gap-6 text-sm">
            <Link to="/gpu-comparison#comparison" className="text-muted-foreground hover:text-foreground transition-colors">
              GPU Comparison
            </Link>
            <Link to="/gpu-comparison#benchmarks" className="text-muted-foreground hover:text-foreground transition-colors">
              Benchmarks
            </Link>
            <Link to="/gpu-comparison#methodology" className="text-muted-foreground hover:text-foreground transition-colors">
              Methodology
            </Link>
            <Link to="/gpu-comparison#faq" className="text-muted-foreground hover:text-foreground transition-colors">
              FAQ
            </Link>
          </nav>

          {/* Copyright */}
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} GPU Compare. All rights reserved.
          </p>
        </div>

        {/* Legal Links */}
        <div className="mt-6 flex flex-wrap justify-center gap-6 text-sm">
          <Link to="/auth" className="text-muted-foreground hover:text-foreground transition-colors">
            Sign In
          </Link>
          <Link to="/account" className="text-muted-foreground hover:text-foreground transition-colors">
            Account
          </Link>
          <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">
            Terms of Service
          </Link>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 pt-8 border-t text-center">
          <p className="text-xs text-muted-foreground max-w-2xl mx-auto">
            Performance rankings are approximate and based on aggregated benchmark data. 
            Actual performance may vary based on system configuration, drivers, and specific applications. 
            Prices shown are MSRP and may differ from current market prices.
          </p>
        </div>
      </div>
    </footer>
  );
};
